import React from "react";
var __jsx = React.createElement;
import { VideoInput } from 'components/common/VideoInput';

var VideoField = function VideoField(_ref) {
  var formField = _ref.formField;
  return __jsx(VideoInput, {
    name: formField.name,
    labelId: formField.labelId,
    defaultValue: formField.defaultValue
  });
};

export default VideoField;